<template>
  <div class="disable-double-tap">
    <v-row
      class="disable-double-tap"
      align="center"
      no-gutters
      :style="
        hoverShape &&
        type.codigo_produto === hoverShape &&
        type.mapa_coordenadas &&
        type.mapa_coordenadas.length
          ? 'background-color: rgba(255,255,0,0.1)'
          : expanded
          ? 'background-color: #f1f1f1'
          : ''
      "
      @mouseenter="$store.commit('SET_HOVER_SHAPE', type.codigo_produto)"
      @mouseleave="$store.commit('SET_HOVER_SHAPE', null)"
      :class="index === 0 && indexProduct === 0 ? 'py-5' : 'py-5 product-box'"
    >
      <v-col :cols="$vuetify.breakpoint.mdAndUp ? '' : '7'" class="pl-6">
        <v-row no-gutters>
          <span
            class="accent--text checkout-h3"
            style="font-weight: 450 !important"
            >{{ expanded ? "" : `${type.nome} - ` }}{{ type.nome_tipo }}
          </span>
        </v-row>
        <v-row v-if="!type.esgotado" no-gutters style="font-weight: normal">
          <span v-html="productPriceDetails(type)"></span>
        </v-row>
      </v-col>

      <v-chip class="mr-5" v-if="type.esgotado" outlined color="#838D9B"
        >Esgotado</v-chip
      >

      <v-row v-else-if="!type.encerrado" justify="end" no-gutters>
        <v-tooltip
          v-if="
            (product && product[0] && product[0]?.observacoes) ||
            type?.observacoes
          "
          color="orange"
          bottom
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              size="24"
              color="orange"
              @click.stop="() => {}"
              style="cursor: default !important; margin-top: -2px"
              v-bind="attrs"
              v-on.stop="on"
              >mdi-information</v-icon
            >
          </template>
          <v-row style="width: 200px !important" no-gutters>
            <span>{{
              type?.observacoes ? type?.observacoes : product[0]?.observacoes
            }}</span>
          </v-row>
        </v-tooltip>
        <v-icon
          class="disable-double-tap"
          color="primary"
          style="margin-right: 5px; margin-left: 20px"
          @click="remove(type)"
          :disabled="type.quantidade === 0"
          >mdi-minus-circle-outline</v-icon
        >
        <span class="checkout-h2 box-number">{{ type.quantidade }}</span>
        <v-icon
          class="mr-5 disable-double-tap"
          color="primary"
          style="margin-left: 5px"
          @click="add(type)"
          :disabled="
            type.quantidade >= type.quantidade_maxima ||
            (productsQuantity >= maxProductsPerCpf && maxProductsPerCpf) ||
            (productsQuantity >= eventDetails.max_produtos_pedido &&
              eventDetails.max_produtos_pedido) ||
            (!!type.cupom && productsQuantityCoupon >= maxProductsPerCoupon)
          "
          >mdi-plus-circle-outline</v-icon
        >
      </v-row>
      <v-row v-else justify="end" class="mr-5" no-gutters>
        <v-chip outlined color="#838D9B">{{ $t("cart.closed") }}</v-chip>
      </v-row>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: [
    "type",
    "eventDetails",
    "expanded",
    "index",
    "indexProduct",
    "product",
  ],
  computed: {
    ...mapGetters([
      "cartProducts",
      "maxProductsPerCpf",
      "productsQuantity",
      "hoverShape",
      "maxProductsPerCoupon",
      "productsQuantityCoupon",
    ]),
  },

  methods: {
    productPriceDetails(product) {
      const value = this.$options.filters.currency(product.valor);
      const tax = product.valor_conveniencia
        ? ` + ${this.$options.filters.currency(
            product.valor_conveniencia
          )} taxa`
        : "";
      const lote = ` (Lote ${product.lote})`;
      return `<span style="font-size: 14px; font-weight: 300; color: ${
        product.cupom === 1 ? "#00A65A" : "#1976d2"
      }">${value}</span><span style="font-size: 14px; font-weight: 300">${tax}    ${
        this.$vuetify.breakpoint.mdAndUp ? "" : "<br/>"
      }${
        this.eventDetails &&
        this.eventDetails.exibir_lote &&
        product.tipo_produto !== "M"
          ? lote
          : ""
      }</span>`;
    },
    add(product) {
      if (product.quantidade === 0 && product.quantidade_minima > 1) {
        for (var i = 0; i < product.quantidade_minima; i++) {
          this.$store.dispatch("addCartProduct", product);
        }
      } else {
        this.$store.dispatch("addCartProduct", product);
      }
    },
    remove(product) {
      if (product.quantidade <= 0) product.quantidade = 0;
      if (product.quantidade > 0) {
        if (product.quantidade === product.quantidade_minima) {
          for (var i = 0; i < product.quantidade_minima; i++) {
            this.$store.dispatch("removeCartProduct", product);
          }
        } else {
          this.$store.dispatch("removeCartProduct", product);
        }
      }
    },
  },
};
</script>

<style scoped>
.product-box {
  border-top: 1px solid #dfdfdf !important;
}

.box-number {
  display: flex;
  justify-content: center;
  width: 22px;
}
</style>
